module.exports = __webpack_public_path__ + "media/customizations/tavolalife/back-7b40e755f81b3b50d28119838a328ef4.jpg";